import { AxiosResponse } from 'axios'
import AxiosClient from '@services/api/base'
import { LectureProgress } from '@type/course'
import routes from '@configs/api'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Cookies from 'js-cookie'

/**
 * Update course lecture progress
 * @param courseId
 * @param lectureProgress
 */
const updateCourseLectureProgress = (
  courseId: string | string[],
  lectureProgress: LectureProgress
): Promise<LectureProgress> => {
  return new Promise((resolve, reject) => {
    const tokenId = Cookies.get(AUTH_TOKEN_KEY)
    const URL = routes.COURSE + courseId + '/lecture-progress'
    const config = {
      headers: {
        Authorization: `Bearer ${tokenId}`,
      },
    }
    const data = {
      lecture_progress: lectureProgress,
    }
    AxiosClient.put(URL, data, config)
      .then((res: AxiosResponse<LectureProgress>) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export default updateCourseLectureProgress
